const translations = {
  FOOTER_RIGHTS: {
    description:
      "This is a footer text that is displayed on the right side of the footer",
    primaryValue: "Nike Inc. All Rights Reserved.",
    stringKey: "FOOTER_RIGHTS",
  },
  FOOTER_PASS_POLICY: {
    description:
      "This is a footer PassPolicy link that is displayed on the right side of the footer",
    primaryValue: "Pass Policy ",
    stringKey: "FOOTER_PASS_POLICY",
  },
  FOOTER_PRIVACY_POLICY: {
    description:
      "This is a footer Privacy Policy link that is displayed on the right side of the footer",
    primaryValue: "Privacy Policy",
    stringKey: "FOOTER_PRIVACY_POLICY",
  },
  FOOTER_TERMS_OF_USE: {
    description:
      "This is a footer terms of use link that is displayed on the right side of the footer",
    primaryValue: "Terms of Use",
    stringKey: "FOOTER_TERMS_OF_USE",
  },
  COMP_PRODUCT_POLICY: {
    description:
      "This is a footer Comp Product link that is displayed on the right side of the footer",
    primaryValue: "Comp Product Policy",
    stringKey: "COMP_PRODUCT_POLICY",
  },
};

export default translations;
